import { lazy, Suspense, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'

import { AcceptInvitePage } from 'features/CustomerPortal/ConnectedParties/AcceptInvitePage'

import { SystemManagementPage } from 'pages/SystemManagementPage/SystemManagementPage'

import Spinning from './components/Common/Spinner/Spinning'
import LandingPage from './components/LandingPage/LandingPage'
import Workspaces from './components/Organizations/Workspaces'

import AppError from './AppError'
import Login from './Login'
import { Logout } from './Logout'
import AppPage from './pages/AppPage/AppPage'
import { checkAppVersion } from 'components/checkAppVersion'
import { OnlyAuthenticated } from 'components/OnlyAuthenticated'
import { OnlyWithOrganization } from 'components/OnlyWithOrganization'
import { OnlyNOTAuthenticated } from 'components/OnlyNOTAuthenticated'

import SettingsPage from './components/OrganizationSettings/SettingsPage'
import { PartiesPage } from 'pages/SystemManagementPage/ManagementPages/PartiesPages/PartiesPages'
import HandleAuthentication from 'components/Common/HandleAuthentication'

const UserProfile = lazy(
  () => import('./components/OrganizationSettings/General/UserProfilePage')
)

const ProjectContainer = lazy(() => import('./pages/ProjectPage/ProjectPage'))

export const AppRoutes = () => {
  const { t } = useTranslation('common')
  const location = useLocation()

  useEffect(() => {
    checkAppVersion(t)

    window.parent?.postMessage(
      {
        type: 'RH24_EMBEDDED_LOCATION_CHANGE',
        payload: { ...location },
      },
      '*'
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  return (
    <Suspense fallback={<Spinning />}>
      <>
        <Routes>
          <Route path="/auth/callback" element={<HandleAuthentication />} />
          <Route path="/app/acceptinvite" element={<AcceptInvitePage />} />
          {/* ONLY AUTHENTICATED ROUTES */}
          <Route path="/app" element={<OnlyAuthenticated />}>
            {/* ONLY ROUTES WITH ORGANIZATION_ID SETTED */}
            <Route path="" element={<OnlyWithOrganization />}>
              <Route index element={<AppPage />} />
              <Route path="settings/*" element={<SettingsPage />} />
              <Route path="project/:projectId" element={<ProjectContainer />} />
              <Route
                path="project/:projectId/bomItem/:bomItemId"
                element={<ProjectContainer />}
              />
              <Route
                path="system-management"
                element={<SystemManagementPage />}
              >
                <Route index element={<h3>System Management</h3>} />
                <Route path="parties" element={<PartiesPage />} />
              </Route>
            </Route>
            {/* END --- ONLY ROUTES WITH ORGANIZATION_ID SETTED */}

            <Route
              path="workspaces"
              element={<Workspaces />}
            />

            <Route
              path="user"
              element={<UserProfile containerMaxWidth={'lg'} />}
            />
          </Route>
          {/* END --- ONLY AUTHENTICATED ROUTES */}

          {/* ONLY NOT AUTHENTICATED ROUTES */}
          <Route element={<OnlyNOTAuthenticated />}>
            <Route path="/login" element={<Login />} />
          </Route>
          {/* END --- ONLY NOT AUTHENTICATED ROUTES */}

          <Route path="/" element={<LandingPage />} />
          <Route path="/app/error" element={<AppError />} />

          {/* <Route path="/auth/callback/*" element={<HandleAuthentication />} /> */}
          <Route path="/logout" element={<Logout />} />

          <Route path="*" element={<Navigate replace to="/" />} />
        </Routes>
      </>
    </Suspense>
  )
}

export default AppRoutes
